/**
 * Settings page translations
 */
export const settings = {
  en: {
    title: "Settings",
    subtitle: "Manage your account settings and preferences",
    account: "Account",
    accountDesc: "Update your personal information",
    fullName: "First Name",
    lastName: "Last Name",
    userHandle: "User Handle",
    userHandlePlaceholder: "@username",
    email: "Email",
    emailHelp: "Contact support to change your email address",
    profileUpdated: "Profile updated successfully",
    profileUpdateError: "Failed to update profile",
    saveChanges: "Save Changes",
    saving: "Saving...",
    saved: "Saved",
    appearance: "Appearance",
    appearanceDesc: "Customize how the dashboard looks",
    theme: "Theme",
    themeDesc: "Select your preferred color theme",
    light: "Light",
    dark: "Dark (soon)",
    language: "Language",
    languageDesc: "Choose your preferred language",
    notifications: "Notifications",
    notificationsDesc: "Configure how you receive notifications",
    emailAlerts: "Email Alerts",
    emailAlertsDesc: "Receive important alerts via email",
    weeklyReports: "Weekly Reports",
    weeklyReportsDesc: "Receive weekly summary reports",
    marketingEmails: "Marketing Emails",
    marketingEmailsDesc: "Receive product updates and news",
    security: "Security",
    securityDesc: "Manage your security settings",
    password: "Password",
    passwordDesc: "Change your account password",
    changePassword: "Change Password",
    twoFactor: "Two-Factor Authentication",
    twoFactorDesc: "Add an extra layer of security",
    comingSoon: "Coming Soon",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    enterNewPassword: "Enter new password",
    confirmNewPassword: "Confirm new password",
    passwordRequirements: "Requirements: at least 8 characters, one uppercase, one lowercase, and one number.",
    passwordUpdated: "Password updated successfully!",
    updatePassword: "Update Password",
    updating: "Updating...",
    updated: "Updated!",
    cancel: "Cancel",
    // Password validation
    passwordMinLength: "Password must be at least 8 characters",
    passwordLowercase: "Password must contain at least one lowercase letter",
    passwordUppercase: "Password must contain at least one uppercase letter",
    passwordNumber: "Password must contain at least one number",
    passwordsDoNotMatch: "Passwords do not match",
    notAuthenticated: "Not authenticated. Please log in again.",
    failedToUpdatePassword: "Failed to update password",
    // Aria labels
    showPassword: "Show password",
    hidePassword: "Hide password",
    loadingSettings: "Loading settings",
    // Avatar
    profilePhoto: "Profile Photo",
    profilePhotoDesc: "Upload a photo to personalize your account",
    uploadPhoto: "Upload Photo",
    removePhoto: "Remove Photo",
    photoUploaded: "Photo updated",
    photoRemoved: "Photo removed",
    photoUploadError: "Error uploading photo",
    photoTooLarge: "Image too large. Max 5 MB.",
    photoInvalidType: "Only PNG, JPG, or WebP images",
  },
  es: {
    title: "Configuración",
    subtitle: "Administra tu cuenta y preferencias",
    account: "Cuenta",
    accountDesc: "Actualiza tu información personal",
    fullName: "Nombre",
    lastName: "Apellido",
    userHandle: "Usuario",
    userHandlePlaceholder: "@usuario",
    email: "Correo Electrónico",
    emailHelp: "Contacta a soporte para cambiar tu correo",
    profileUpdated: "Perfil actualizado exitosamente",
    profileUpdateError: "Error al actualizar el perfil",
    saveChanges: "Guardar Cambios",
    saving: "Guardando...",
    saved: "Guardado",
    appearance: "Apariencia",
    appearanceDesc: "Personaliza cómo se ve el panel",
    theme: "Tema",
    themeDesc: "Selecciona tu tema de color preferido",
    light: "Claro",
    dark: "Oscuro (próximamente)",
    language: "Idioma",
    languageDesc: "Elige tu idioma preferido",
    notifications: "Notificaciones",
    notificationsDesc: "Configura cómo recibes notificaciones",
    emailAlerts: "Alertas por Correo",
    emailAlertsDesc: "Recibe alertas importantes por correo",
    weeklyReports: "Reportes Semanales",
    weeklyReportsDesc: "Recibe resúmenes semanales",
    marketingEmails: "Correos de Marketing",
    marketingEmailsDesc: "Recibe actualizaciones y noticias",
    security: "Seguridad",
    securityDesc: "Administra tu configuración de seguridad",
    password: "Contraseña",
    passwordDesc: "Cambiar la contraseña de tu cuenta",
    changePassword: "Cambiar Contraseña",
    twoFactor: "Autenticación de Dos Factores",
    twoFactorDesc: "Añade una capa extra de seguridad",
    comingSoon: "Próximamente",
    newPassword: "Nueva Contraseña",
    confirmPassword: "Confirmar Contraseña",
    enterNewPassword: "Ingresa nueva contraseña",
    confirmNewPassword: "Confirma nueva contraseña",
    passwordRequirements: "Requisitos: al menos 8 caracteres, una mayúscula, una minúscula y un número.",
    passwordUpdated: "¡Contraseña actualizada!",
    updatePassword: "Actualizar Contraseña",
    updating: "Actualizando...",
    updated: "¡Actualizado!",
    cancel: "Cancelar",
    // Password validation
    passwordMinLength: "La contraseña debe tener al menos 8 caracteres",
    passwordLowercase: "La contraseña debe contener al menos una letra minúscula",
    passwordUppercase: "La contraseña debe contener al menos una letra mayúscula",
    passwordNumber: "La contraseña debe contener al menos un número",
    passwordsDoNotMatch: "Las contraseñas no coinciden",
    notAuthenticated: "No autenticado. Inicia sesión de nuevo.",
    failedToUpdatePassword: "Error al actualizar la contraseña",
    // Aria labels
    showPassword: "Mostrar contraseña",
    hidePassword: "Ocultar contraseña",
    loadingSettings: "Cargando configuración",
    // Avatar
    profilePhoto: "Foto de Perfil",
    profilePhotoDesc: "Sube una foto para personalizar tu cuenta",
    uploadPhoto: "Subir Foto",
    removePhoto: "Eliminar Foto",
    photoUploaded: "Foto actualizada",
    photoRemoved: "Foto eliminada",
    photoUploadError: "Error al subir foto",
    photoTooLarge: "Imagen demasiado grande. Máximo 5 MB.",
    photoInvalidType: "Solo imágenes PNG, JPG o WebP",
  },
};
